import Component from "./GameCalculations";
export default Component;
